import { render, staticRenderFns } from "./LeaveInfoStat.vue?vue&type=template&id=54cfa60e"
import script from "./LeaveInfoStat.vue?vue&type=script&lang=js"
export * from "./LeaveInfoStat.vue?vue&type=script&lang=js"
import style0 from "./LeaveInfoStat.vue?vue&type=style&index=0&id=54cfa60e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports